import { ChoicesController } from './choices.controller';
import { ChoiceProps } from './choices.model';

export const Choices = (props: ChoiceProps) => {
  return <ChoicesController {...props} />;
};
